const ensureAdminIncluded = (userIds, adminId) => [
  ...new Set([...(userIds || []), ...(adminId ? [adminId] : [])]),
];

export default ensureAdminIncluded;
